export let krtex_1_1 = {
	"name": "krtex_1_1",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Укажите разделы криминалистики:",
				"correct_ans": [
					{
						"ans": "Методика расследования отдельных видов преступлений",
						"score": 20
					},
					{
						"ans": "Общая теория криминалистики",
						"score": 20
					},
					{
						"ans": "Криминалистическая техника",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Расследование хищений имущества - это одна из частных методик.",
						"ans": "Расследование хищений имущества",
						"score": 0
					},
					{
						"comm": "Криминалистическое учение о следах - это подраздел кримтехники.",
						"ans": "Криминалистическое учение о следах",
						"score": 0
					},
					{
						"comm": "Криминалистическая габитоскопия (габитология) - это подраздел кримтехники.",
						"ans": "Криминалистическая габитоскопия (габитология)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_1_2 = {
	"name": "krtex_1_2",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Подозреваемый был опознан потерпевшим как лицо, скрывшееся с места происшествия. Какой вид идентификации произведен?",
				"correct_ans": [
					{
						"ans": "По мысленному образу",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "По материально фиксированным отображениям",
						"score": 0
					},
					{
						"ans": "По описаниям признаков",
						"score": 0
					},
					{
						"ans": "По источнику общего происхождения",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "При опознании потерпевший сравнивает внешние признаки преступника, которые запечатлелись у него в памяти в виде мысленного образа (А), и признаки подозреваемого лица (Б). Когда совокупность признаков (А) и (Б) совпадает, мы говорим о том, что данный объект идентифицирован (преступник опознан)"
}

export let krtex_1_3 = {
	"name": "krtex_1_3",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Назовите частные идентификационные признаки из ниже перечисленных",
				"correct_ans": [
					{
						"ans": "Мелкие детали следов нарезов на пуле",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Рисунок протектора колеса автомашины",
						"score": 0
					},
					{
						"ans": "Модель огнестрельного оружия",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Идентификационные признаки делятся на общие, позволяющие отнести исследуемый объект к определенному виду, классу, группе, однородных с ним (в данном случае это рисунок протектора колеса автомашины и модель огнестрельного оружия) и частные (в данном случае это рисунок протектора колеса автомашины и модель огнестрельного оружия), позволяющие из числа однородных объектов найти конкретный искомый объект"
}

export let krtex_1_4 = {
	"name": "krtex_1_4",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Из перечисленных назовите отождествляющий объект неизвестного происхождения",
				"correct_ans": [
					{
						"ans": "след пальца с места происшествия",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "образцы следов пальцев рук подозреваемого",
						"score": 0
					},
					{
						"ans": "образцы следов пальцев рук потерпевшего",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Все перечисленные объекты относятся к отождествляющим, но к неизвестным только один из них - след пальца с места происшествия, принадлежность же остальных известна"
}

export let krtex_1_5 = {
	"name": "krtex_1_5",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Как называется учение об общих принципах и методике исследования материальных объектов с целью установления тождества?",
				"correct_ans": [
					{
						"ans": "Криминалистическая идентификация",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Криминалистическая экспертиза - это процессуальное действие, направленное на установление обстоятельств дела и состоящее в проведении исследования на основе специальных познаний в науке, технике, искусстве или ремесле и даче заключения сведующим лицом по поручению органов предварительного расследования и суда.",
						"ans": "Криминалистическая экспертиза",
						"score": 0
					},
					{
						"comm": "Криминалистическая техника - это раздел криминалистики, представляющий систему научных положений и, основанных на них криминалистических рекомендациях,о технических средствах и методах обнаружения, фиксации, изъятия и исследования обстановки и следов преступления в целях расследования и предупреждения преступлений.",
						"ans": "Криминалистическая техника",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_1_6 = {
	"name": "krtex_1_6",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "На месте взлома двери склада обнаружена часть жала отвертки, а у подозреваемого - сломанная отвертка. Что в данном случае является идентифицируемым объектом?",
				"correct_ans": [
					{
						"ans": "Целая отвертка",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Сломанная отвертка",
						"score": 0
					},
					{
						"ans": "Часть жала отвертки",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "\"Идентифицируемый\" - то же, что \"устанавливаемый\". В данном случае устанавливаемый объект - инструмент, используемый при взломе двери склада, то есть сама отвертка"
}

export let krtex_1_7 = {
	"name": "krtex_1_7",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Судебно-баллистической экспертизой установлено, что извлеченная из трупа пуля выстрелена из пистолета, изъятого у подозреваемого. К какому виду идентификации относится данное исследование?",
				"correct_ans": [
					{
						"ans": "По материально фиксированным отображениям",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "По отображениям в памяти",
						"score": 0
					},
					{
						"ans": "По источнику общего происхождения",
						"score": 0
					},
					{
						"ans": "По описаниям признаков",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Особенности микроструктуры внутренней поверхности ствола пистолета отобразились на пуле в виде трасс, относящихся к материальным следам, отсюда и вид идентификации"
}

export let krtex_1_8 = {
	"name": "krtex_1_8",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Что составляет сущность криминалистической идентификации?",
				"correct_ans": [
					{
						"ans": "Установление тождества объекта",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Сущность обнаружения следов на месте происшествия - поиск того, что имеет отношение к расследуемому событию.",
						"ans": "Обнаружение следов на месте происшествия, имеющих отношение к расследуемому событию",
						"score": 0
					},
					{
						"comm": "Деятельность по установлению личности, совершившей преступление более широкое понятие, которое включает возможность применения методов идентификации.",
						"ans": "Установление личности, совершившей данное преступление",
						"score": 0
					},
					{
						"comm": "Подтверждение версии по уголовному делу есть факт установления соответствия предположения действительности, причем не обязательно путем установления тождества какого - то объекта.",
						"ans": "Подтверждение версии по уголовному делу",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_1_9 = {
	"name": "krtex_1_9",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Из заключения эксперта: \"След обуви, обнаруженный при осмотре места происшествия, слепок которого представлен на исследование, и правый ботинок,изъятый в квартире подозреваемого, имеют одинаковые размер и форму рисунка на подметке в виде \"елочки\". Что здесь установлено?",
				"correct_ans": [
					{
						"ans": "Групповая принадлежность",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Здесь нельзя говорить о тождестве, так как выявлены лишь общие признаки объектов. Вывод об этом мог быть сделан только в том случае, если бы были выявлены индивидуальные, совпадающие признаки, например форма, размеры и местоположение набойки на подошве обуви.",
						"ans": "Тождество обуви",
						"score": 0
					},
					{
						"comm": "Общие источник происхождения устанавливается по признакам физических, химических и иных свойств веществ и материалов (например, когда образцы почвы с места происшествия и частицы почвы, обнаруженные на подошве обуви подозреваемого, имеют общий состав входящих в нее веществ.",
						"ans": "Общий источник происхождения",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_1_10 = {
	"name": "krtex_1_10",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Назовите объекты, относительно которых можно установить только групповую принадлежность",
				"correct_ans": [
					{
						"ans": "Тол (взрывчатое вещество)",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Пистолет",
						"score": 0
					},
					{
						"ans": "Обувь, с набойкой на каблуке",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Тол как вещество может быть по составу и свойствам входящих в него компонентов отнесено к определенной группе веществ, имеющих те же характеристики. Что касается других объектов, то они могут быть при определенных условиях идентифицированы"
}

export let krtex_1_11 = {
	"name": "krtex_1_11",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Оперативный работник направил в ГИАЦ МВД карту на неопознанный труп. В результате проверки по криминалистическим учетам была установлена личность погибшего. К какому виду идентификации следует отнести данное исследование?",
				"correct_ans": [
					{
						"ans": "По описаниям признаков",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "По отображениям в памяти",
						"score": 0
					},
					{
						"ans": "По источнику общего происхождения",
						"score": 0
					},
					{
						"ans": "По материально фиксированным отображениям",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В учетную карточку на неопознанный труп ( в числе других сведений) заносятся (описываются) признаки его внешности. Описание признаков в карточке сопоставляют с описанием признаков неопознанного трупа. При совпадении достаточного количества признаков личность трупа может быть установлена., т.е. происходит его идентификация по описанию признаков"
}

export let krtex_1_12 = {
	"name": "krtex_1_12",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Какой из указанных этапов идентификации является завершающим?",
				"correct_ans": [
					{
						"ans": "Установление тождества",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Установление групповой принадлежности",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Суть установления групповой принадлежности - отнесение исследуемого объекта по ряду признаков к группе, классу ему однородных. Следовательно этот этап не окончательный, а промежуточный, на пути к установлению конкретного, единичного объекта - установлнеия тождества"
}

export let krtex_1_13 = {
	"name": "krtex_1_13",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "При расследовании уголовного дела об убийстве на месте происшествия были обнаружены ряд следов и объектов. Что из перечисленного является идентифицируемым объектом?",
				"correct_ans": [
					{
						"ans": "Пистолет в колодце",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "След обуви у пролома в заборе",
						"score": 0
					},
					{
						"ans": "След пальца в помещении склада",
						"score": 0
					},
					{
						"ans": "Гильза на земле у склада",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Требуется установить не из данного ли пистолета было совершено убийство. Это возможно только в том случае, если в распоряжении эксперта-криминалиста имеются идентифицирующие объекты (в данном случае это гильза). Любые следы на месте происшествия всегда идентифицирующие объекты, в том числе след обуви и след пальца, обнаруженные при осмотре места происшествия"
}

export let krtex_1_14 = {
	"name": "krtex_1_14",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Что из перечисленного по делу о разбойном нападении является идентифицирующим объектом?",
				"correct_ans": [
					{
						"ans": "Пуля, изъятая из трупа охранника",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Пистолет, обнаруженный у подозреваемого",
						"score": 0
					},
					{
						"ans": "Обувь, изъятая у подозреваемого",
						"score": 0
					},
					{
						"ans": "Автомашина на которой скрылись преступники",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Идентифицирующим объектом здесь является только пуля, изъятая из трупа охранника. Другие перечисленные объекты относятся к идентифицируемым, то есть устанавливаемым объектам"
}

export let krtex_1_15 = {
	"name": "krtex_1_15",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "Заполните пропуск в следующем утверждении: \"Чем больше идентификационных признаков установлено в процессе сравнительного исследования, тем более (....) группу объектов они характеризуют\"",
				"correct_ans": [
					{
						"ans": "узкую",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "широкую",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Чем больше идентификационных признаков установлено в процессе сравнительного исследования, тем более узкую группу объектов они характеризуют. Рассмотрим это утверждение на примере. Свидетель (милиционер пытавшийся задержать скрывшихся преступников) на допросе смог вспомнить и назвал всего два признака внешности одного из них: высокий рост, телосложение плотное. В результате проведенных оперативно-розыскных мероприятий было установлено пятеро мужчин, которые могли быть причастны к данному преступлению. Все они оказались высокого роста и плотного телосложения. При повторном допросе свидетель вспомнил, что на преступнике была дубленка. Круг подозреваемых сузился до трех человек, постоянно носящих дубленку. Затем свидетель сообщил, что преступник, отстреливаясь, держал пистолет все время в левой руке, что может свидетельствовать, что он левша. Этот признак позволил отбросить еще трех из установленных граждан. Таким образом, если в начале были данные только о двух признаках внешности подозреваемого, а их в этот момент пять человек, то к финалу признаков стало четыре, а подозреваемых только два. То есть при увеличении признаков круг объектов, которые они характеризуют уменьшился"
}

export let krtex_1_16 = {
	"name": "krtex_1_16",
	"descriprion": "type2",
	"theme": "Идентификация",
	"title": "Идентификация",
	"data": {
		"questions": [
			{
				"qst": "К научным основам идентификации относится:",
				"correct_ans": [
					{
						"comm": "К этому можно добавить, что к научным основам идентификации также относится и индивидуальность, т. е. безусловное отличие данного объекта от любых других.",
						"ans": "относительная устойчивость идентифицируемых объектов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ну разве могут быть тождественны идентифицируемый (например пистолет из которого убит сторож) и идентифицирующий (пуля, изъятая из трупа сторожа) объекты ?! Запомните : идентифицируемый объект тождественен только самому себе ! Правильный ответ: относительная устойчивость идентифицируемых объектов. К этому можно добавить, что к научным основам идентификации также относится и индивидуальность, т. е. безусловное отличие данного объекта от любых других.",
						"ans": "тождество идентифицируемого и идентифицирующего объектов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_2_1 = {
	"name": "krtex_2_1",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "Какой из пунктов \"ошибочно\" включен в перечень разделов криминалистической техники?",
				"correct_ans": [
					{
						"ans": "Криминалистическая экспертиза",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Криминалистическая фотография и видеозапись",
						"score": 0
					},
					{
						"ans": "Габитоскопия",
						"score": 0
					},
					{
						"ans": "Криминалистическое исследование документов",
						"score": 0
					},
					{
						"ans": "Трассология",
						"score": 0
					},
					{
						"ans": "Криминалистическое оружиеведение",
						"score": 0
					},
					{
						"ans": "Криминалистическая регистрация",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Криминалистическая экспертиза - одна из форм использования специальных познаний и в первую очередь в области криминалистической техники, но ей определено место в другом разделе криминалистики - \"Криминалистическая тактика\""
}

export let krtex_2_2 = {
	"name": "krtex_2_2",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "Что относится к процессуальной форме применения технико-криминалистических средств и методов ?",
				"correct_ans": [
					{
						"ans": "Проведение криминалистических экспертиз",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Проверка по криминалистическим учетам",
						"score": 0
					},
					{
						"ans": "Получение консультаций специалистов-криминалистов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Криминалистическая экспертиза - это следственное действие (и следовательно процессуальное). Проверка по криминалистическим учетам и получение консультаций специалистов-криминалистов - это не процессуальная форма использования специальных познаний,так как прямо не оговаривается в уголовно-процессуальном законе и используются в виде вспомогательных мероприятий. Их результаты выполняют лишь ориентирующую, информационную задачу в расследовании преступлений"
}

export let krtex_2_3 = {
	"name": "krtex_2_3",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "В каком пункте правильно названы этапы применения специальных познаний при осмотре места происшествия?",
				"correct_ans": [
					{
						"ans": "Собирание, исследование и оценка доказательств, полученных при осмотре места происшествия",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Здесь необходимо уточнить следующее: во-первых, криминалистическое понятие \"собирание доказательств\" включает обнаружение, фиксацию и изъятие доказательств и во-вторых, Вами не названы два завершающих этапа: исследование и оценка доказательств.",
						"ans": "Обнаружение, собирание и фиксация следов на месте происшествия",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_2_4 = {
	"name": "krtex_2_4",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "Назовите основную цель применения криминалистической техники",
				"correct_ans": [
					{
						"ans": "Обнаружение, фиксация, изъятие и исследование доказательств",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Исследование доказательств экспертом-криминалистом скорее задача, а не цель.",
						"ans": "Исследование доказательств экспертом-криминалистом",
						"score": 0
					},
					{
						"comm": "Установление вины преступника - одно из обстоятельств, подлежащих установлению по любому уголовному делу и является категорией уголовного права, а не криминалистики. Область применения криминалистических средств и методов ограничена задачей: способствовать раскрытию преступлений (в том числе установлению лица, причастного к совершенному или подготавливаемому деянию, но не его вины).",
						"ans": "Установление вины преступника",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_2_5 = {
	"name": "krtex_2_5",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "Как называется система научных положений и основанных на них технических средств, приемов и методов, используемых для собирания и исследования доказательств для раскрытия и предупреждения преступлений?",
				"correct_ans": [
					{
						"ans": "Криминалистическая техника",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Криминалистическая экспертиза - это процессуальное действие, проводимое по поручению органов дознания, предварительного расследования и суда, заключающееся в специальном исследовании в области науки, техники, искусства или ремесла уполномоченным лицом с выдачей заключения, в целях установления обстоятельств совершенного преступления.",
						"ans": "Криминалистическая экспертиза",
						"score": 0
					},
					{
						"comm": "Криминалистика - наука о механизме преступления, закономерностях возникновения информации о преступлении и его участниках, закономерностях собирания, исследования, оценки и использования доказательств и основанных на познании этих закономерностей специальных средствах и методах раскрытия, расследования и предотвращения преступлений.",
						"ans": "Криминалистика",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_2_6 = {
	"name": "krtex_2_6",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "В трупе имеется пулевое слепое огнестрельное повреждение. Какое исследование необходимо провести для обнаружения пули в теле трупа?",
				"correct_ans": [
					{
						"ans": "Рентгеновское исследование",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Люминесцентный анализ - это метод с помощью которого используемые лучи невидимого спектра (обычно ультрафиолетовые и инфракрасные) вызывают свечение некоторых веществ и материалов, что позволяет визуально отделить такие вещества или их следы от других, ничем не отличающихся от них в обычных условиях.",
						"ans": "Люминесцентный анализ",
						"score": 0
					},
					{
						"comm": "Только рентгеновское исследование позволит обнаружить металлический предмет внутри какого-то препятствия неметаллической природы. Инфракрасные и ультрафиолетовые лучи такой возможностью не обладают.",
						"ans": "Исследование в инфракрасных лучах",
						"score": 0
					},
					{
						"comm": "Только рентгеновское исследование позволит обнаружить металлический предмет внутри какого-то препятствия неметаллической природы. Инфракрасные и ультрафиолетовые лучи такой возможностью не обладают.",
						"ans": "Исследование в ультрафиолетовых лучах",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_2_7 = {
	"name": "krtex_2_7",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "Преступник бросил пистолет в колодец. Какой поисковый прибор должен применить следователь для извлечения пистолета?",
				"correct_ans": [
					{
						"ans": "Магнитный искатель-подъемник",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Щуп",
						"score": 0
					},
					{
						"comm": "Металлоискатель не предназначен для извлечения предметов.",
						"ans": "Металлоискатель",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Щуп - палка с длинным металлическим стержнем на конце. Он предназначен для обнаружения объектов поиска, спрятанных (или иным образом оказавшихся) в толще земли, песке, стоге сена и т.п. путем последовательного протыкания исследуемой территории. Поэтому для извлечения пистолета из колодца щуп не пригоден"
}

export let krtex_2_8 = {
	"name": "krtex_2_8",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "На месте происшествия обнаружена коробка из грубого картона, которую преступник, вероятно, брал руками. Какой способ целесообразно применить для обнаружения и окрашивания невидимых следов пальцев рук?",
				"correct_ans": [
					{
						"ans": "Химический",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Физический",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "На поверхности грубого картона потожировые узоры осаждается неравномерно, большей частью в малых количествах, что затрудняет (или вообще делает невозможным) прилипание специальных порошков, используемых при выявлении и фиксапции следов пальцев рук физическим способом. Ествественно, что слабо окрашенный след содержит мало частных идентификационных признаков. Химический же способ заключается в опылении или смачивании следов химическими реактивами, которые и при малых количествах потожирового вещества дают результат лучше, чем применение физического способа, но только на гигроскопичных поверхностях"
}

export let krtex_2_9 = {
	"name": "krtex_2_9",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "В каком случае следователь, допрашивая свидетеля о признаках внешности преступника, использовал технику специального назначения?",
				"correct_ans": [
					{
						"ans": "Применил компьютерную программу \"Фоторобот\" для составления композиционного портрета преступника",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Записал допрос на магнитофон",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Магнитофон - это бытовое техническое средство, а не специальное. Если в магнитофон вмонтировано специальное устройство, позволяющее одновременно с записью голоса (или после этого) проводить исследование его характеристик, то такой прибор можно назвать техникой специального назначения"
}

export let krtex_2_10 = {
	"name": "krtex_2_10",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "Какие данные следует отражать в протоколе осмотра следов орудий взлома?",
				"correct_ans": [
					{
						"ans": "Наличие следов наложения",
						"score": 15
					},
					{
						"ans": "Способы обнаружения, изъятия, упаковки",
						"score": 15
					},
					{
						"ans": "Вид следа взлома, его размеры, структуру",
						"score": 15
					},
					{
						"ans": "Название предмета-следоносителя, место его расположения",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Вопросы эксперту ставятся при назначении экспертизы.",
						"ans": "Вопросы эксперту",
						"score": 0
					},
					{
						"comm": "Способы транспортировки следов не имеет значения.",
						"ans": "Способы транспортировки следов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_2_11 = {
	"name": "krtex_2_11",
	"descriprion": "type2",
	"theme": "Общие положения криминалистической техники",
	"title": "Общие положения криминалистической техники",
	"data": {
		"questions": [
			{
				"qst": "Какие из перечисленных размеров следа обуви необходимо отразить в протоколе?",
				"correct_ans": [
					{
						"ans": "Ширина и длина подошвы",
						"score": 15
					},
					{
						"ans": "Длина и ширина каблука",
						"score": 15
					},
					{
						"ans": "Длина подошвы по окружности",
						"score": 15
					},
					{
						"ans": "Длина подошвы следа",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Длина и ширина шага - это элементы дорожки следов.",
						"ans": "Длина и ширина шага",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_3_1 = {
	"name": "krtex_3_1",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Какой вид фотосъемки в первую очередь должен быть выполнен в ходе осмотра места происшествия на открытой местности?",
				"correct_ans": [
					{
						"ans": "Ориентирующая",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Цель обзорной фотосъемки - запечатлеть само место происшествия с различных сторон.",
						"ans": "Обзорная",
						"score": 0
					},
					{
						"comm": "П.",
						"ans": "Узловая",
						"score": 0
					},
					{
						"comm": "Детальная фотосъемка выполняется с целью запечатлеть объект детального осмотра - каждый след по отдельности.",
						"ans": "Детальная",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_3_2 = {
	"name": "krtex_3_2",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Что означает термин \"глубина резкости\"?",
				"correct_ans": [
					{
						"ans": "Пространство перед фотоаппаратом в пределах которого снимаемые объекты будут обладать резким изображением",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Возможность данного объектива усиливать резкость изображения",
						"score": 0
					},
					{
						"ans": "Показатель объектива, указывающий расстояние до снимаемого объекта",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Определить глубину резкости можно по шкале на объективе. Чем большее значение диафрагмы Вы выберете, тем больше глубина резкости. Так, наибольшая глубина резкости при диафрагме \"16\" и наименьшая при диафрагме \"2\""
}

export let krtex_3_3 = {
	"name": "krtex_3_3",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Произведена фотосъемка места происшествия. В каком случае использовал обзорный вид фотосъемки?",
				"correct_ans": [
					{
						"ans": "Сфотографирован склад с различных точек съемки в его границах",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Фотосъемка склада и прилегающих к нему объектов - это ориентирующая съемка.",
						"ans": "Сфотографирован склад и прилегающие к нему объекты",
						"score": 0
					},
					{
						"comm": "Фотосъемка дорожка следов обуви, идущих в направлении от пролома в заборе к дороге, - это узловая съемка.",
						"ans": "Сфотографирована дорожка следов обуви, идущую в направлении от пролома в заборе к дороге",
						"score": 0
					},
					{
						"comm": "Фотосъемка взломанного замка - это детальная съемка.",
						"ans": "Сфотографирован взломанный замок",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_3_4 = {
	"name": "krtex_3_4",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Какой вид фотосъемки применен при осмотре места происшествия, если сфотографирован с использованием масштабной линейки след орудия взлома на двери склада?",
				"correct_ans": [
					{
						"ans": "Детальный",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ориентирующая фотосъемка предназначена для фиксации места происшествия с прилегающими объектами.",
						"ans": "Ориентирующий",
						"score": 0
					},
					{
						"comm": "Обзорная фотосъемка предназначена для фиксации только места происшествия с различных позиций: спереди, слева, справа и т. д.",
						"ans": "Обзорный",
						"score": 0
					},
					{
						"comm": "Узловая фотосъемка предназначена для фиксации какого-то важного узла на месте происшествия, группы следов на небольшом участке.",
						"ans": "Узловой",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_3_5 = {
	"name": "krtex_3_5",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "В процессе поисковых мероприятий после проведенного осмотра места происшествия, на дне сухого колодца был обнаружен пистолет, из которого, вероятно, был убит охранник. Какой из предложенных объективов необходимо использовать для фотографирования обнаруженного на дне колодца пистолета?",
				"correct_ans": [
					{
						"ans": "Длиннофокусный",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Со средним фокусным расстоянием",
						"score": 0
					},
					{
						"ans": "С малым фокусным расстоянием",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Объективы со средним фокусным расстоянием 50 мм не могут приблизить и увеличить удаленные объекты. Для этого применяются длиннофокусные объективы"
}

export let krtex_3_6 = {
	"name": "krtex_3_6",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Какой из объективов должен использоваться для фотографирования склада, если забор, огораживающий территорию производственно-монтажной конторы, не позволяет отойти на достаточное расстояние, чтобы он полностью поместился в кадре?",
				"correct_ans": [
					{
						"ans": "С малым фокусным расстоянием",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Со средним фокусным расстоянием",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Здесь необходим широкоформатный объектив с небольшим фокусным расстоянием. Запомните: чем меньше фокусное расстояние объектива, тем больше объектов помещается в кадре. Объектив с фокусным расстоянием 100 мм обеспечивает малый угол охвата снимаемой территории, поэтому в данном случае он не подходит"
}

export let krtex_3_7 = {
	"name": "krtex_3_7",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "При увеличении значения диафрагмы как должна быть изменена выдержка, чтобы не изменилась интенсивность светового потока?",
				"correct_ans": [
					{
						"ans": "Увеличена",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Уменьшена",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Если выдержку уменьшить в 2 раза, то световой поток уменьшится (при диафрагме с 5.6 на 8 примерно в 4 раза, что приведет к значительной недодержке при экспозиции и качество снимка при этом, естественно, ухудшится"
}

export let krtex_3_8 = {
	"name": "krtex_3_8",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Какой объектив необходимо использовать, чтобы с одной точки съемки в кадре запечатлеть наибольшее количество объектов?",
				"correct_ans": [
					{
						"ans": "Широкоформатный",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "При использовании среднеформатного объектива охват снимаемой территории и будет средний.",
						"ans": "Среднеформатный",
						"score": 0
					},
					{
						"comm": "При использовании телеобъектива количество объектов попавших в кадр будет наименьшим.",
						"ans": "Телеобъектив",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_3_9 = {
	"name": "krtex_3_9",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Как называется панорама, изготовленная с одной точки съемки?",
				"correct_ans": [
					{
						"ans": "Круговая",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Линейная",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Линейная панорамная фотосъемка осуществляется перемещением фотокамеры по условной линии, идущей параллельно снимаемым объектам"
}

export let krtex_3_10 = {
	"name": "krtex_3_10",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Изготовлена фототаблица из ряда снимков, выполненных с разных точек при параллельном перемещении относительно места происшествия. Какой вид панорамной съемки был применен в данном случае?",
				"correct_ans": [
					{
						"ans": "Линейная панорама",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Круговая панорама",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Круговая панорамная фотосъемка осуществляется перемещением фотокамеры слева направо, или наоборот, по кругу, при этом снимающий находится на одном месте"
}

export let krtex_3_11 = {
	"name": "krtex_3_11",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Какой вид фотосъемки произвел техник-криминалист, запечатлев в одном кадре гильзу и рядом след обуви?",
				"correct_ans": [
					{
						"ans": "Узловой",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ориентирующая фотосъемка предназначена для фиксации места происшествия с прилегающими объектами.",
						"ans": "Ориентирующий",
						"score": 0
					},
					{
						"comm": "Обзорная фотосъемка предназначена для фиксации только места происшествия с различных позиций: спереди, слева, справа и т. д.",
						"ans": "Обзорный",
						"score": 0
					},
					{
						"comm": "Детальная фотосъемка предназначена для фиксации отдельного объекта, находящегося на месте происшествия.",
						"ans": "Детальный",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_3_12 = {
	"name": "krtex_3_12",
	"descriprion": "type2",
	"theme": "Криминалистическая фотография",
	"title": "Криминалистическая фотография",
	"data": {
		"questions": [
			{
				"qst": "Как называется метод фотосъемки, позволяющий получать объемное восприятие изображаемых объектов на фотоснимках?",
				"correct_ans": [
					{
						"ans": "Стереоскопический",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Масштабный способ фотосъемки заключается в использовании масштабной линейки, которую кладут рядом с отдельным объектом и снимают вместе с ним. Это в дальнейшем по фотоснимку помогает, при необходимости, установить истинные размеры сфотографированного объекта.",
						"ans": "Масштабный",
						"score": 0
					},
					{
						"comm": "Панорамный способ фотосъемки заключается в фотографировании объекта (объектов) большой протяженности по целиком или по частям. Во втором случае полученные фотоснимки монтируются вместе.",
						"ans": "Панорамный",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_1 = {
	"name": "krtex_4_1",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "На месте происшествия обнаружен вдавленный след обуви. Как называется такой след,образующийся за счет деформации следовоспринимающего объекта?",
				"correct_ans": [
					{
						"ans": "Объемный",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Следы подразделяются на динамические и статические с учетом особенностей взаимодействия следообразующего и следовоспринимающего объектов (покой или движение). Исходя из заданных условий, оснований для применения данной классификации у Вас нет.",
						"ans": "Динамический",
						"score": 0
					},
					{
						"comm": "Следы подразделяются на динамические и статические с учетом особенностей взаимодействия следообразующего и следовоспринимающего объектов (покой или движение). Исходя из заданных условий, оснований для применения данной классификации у Вас нет.",
						"ans": "Статический",
						"score": 0
					},
					{
						"comm": "Поверхностный след не может быть образован за счет изменения формы следовоспринимающей поверхности.",
						"ans": "Поверхностный",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_2 = {
	"name": "krtex_4_2",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "Как называется след, образующийся в пределах контактирующих поверхностей?",
				"correct_ans": [
					{
						"ans": "Локальный",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Периферический след образуется за пределами контактирующих (иногда и не соприкасающихся) объектов. Такой след как бы обрисовывает контур следообразующего объекта.",
						"ans": "Периферический",
						"score": 0
					},
					{
						"comm": "Следы подразделяются на динамические и статические с учетом особенностей взаимодействия следообразующего и следовоспринимающего объектов (покой или движение). Исходя из заданных условий, оснований для применения данной классификации у Вас нет.",
						"ans": "Статический",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_3 = {
	"name": "krtex_4_3",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "Как называется след, образующийся вследствие изменений, происходящих за границами контактирующих поверхностей?",
				"correct_ans": [
					{
						"ans": "Периферический",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Локальный след образуется в пределах границ контакта взаимодействующих объектов.",
						"ans": "Локальный",
						"score": 0
					},
					{
						"comm": "Следы подразделяются на динамические и статические с учетом особенностей взаимодействия следообразующего и следовоспринимающего объектов (покой или движение). Исходя из заданных условий, оснований для применения данной классификации у Вас нет.",
						"ans": "Статический",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_4 = {
	"name": "krtex_4_4",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "При осмотре места происшествия были обнаружены различные следы. Найдите среди них динамический след",
				"correct_ans": [
					{
						"ans": "Следы распила на дужке замка",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "В этом случае след будет статическим.",
						"ans": "След протектора колеса на грунте, от проехавшей на малой скорости автомашины",
						"score": 0
					},
					{
						"comm": "В этом случае след будет периферическим.",
						"ans": "След обуви на полу, образованный частицами грязи в результате ее осыпания",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_5 = {
	"name": "krtex_4_5",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "Какая из перечисленных задач трасологического исследования относится к идентификационным?",
				"correct_ans": [
					{
						"ans": "Установление тождества объектов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Определение пригодности следов для идентификации",
						"score": 0
					},
					{
						"ans": "Установление свойств исследуемых объектов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Здесь указаны некоторые диагностические задачи"
}

export let krtex_4_6 = {
	"name": "krtex_4_6",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "Укажите следообразующий объект",
				"correct_ans": [
					{
						"ans": "Обувь подозреваемого",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Стол, на котором обнаружен след пальца",
						"score": 0
					},
					{
						"ans": "Дверь склада, на которой обнаружен след от орудия взлома",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Объект (стол, дверь и т.п.), на котором возник след, называется следовоспринимающим, а не следообразующим, поскольку он воспринимает своей поверхностью какое-то внешнее воздействие"
}

export let krtex_4_7 = {
	"name": "krtex_4_7",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "При осмотре места происшествия обнаружены различные следы. Укажите среди них след отслоения",
				"correct_ans": [
					{
						"ans": "След пальца на запыленной поверхности стола",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Данный след возник в результате наслоения потожирового вещества на поверхность пистолета, и поэтому называется следом наслоения, а не отслоения.",
						"ans": "Потожировой след пальца на кожухе затвора пистолета",
						"score": 0
					},
					{
						"comm": "Данный след возник в результате наслоения частиц мела на поверхность пола, и поэтому называется следом наслоения, а не отслоения.",
						"ans": "След обуви на полу склада, образованный частицами мела",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_8 = {
	"name": "krtex_4_8",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "При осмотре помещения склада следователь обнаружил на запыленной полке след прямоугольной формы, в границах которого пыли не было. Им было выдвинуто предположение, что во время преступления на этом месте находился предмет, основание которого было прямоугольным (возможно ящик или коробка). Как называется такой след?",
				"correct_ans": [
					{
						"ans": "Периферический",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Локальный",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Локальный след образуется в пределах контактирующих поверхностей"
}

export let krtex_4_9 = {
	"name": "krtex_4_9",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "При осмотре места происшествия обнаружены различные следы. Укажите след - отображение",
				"correct_ans": [
					{
						"ans": "Вдавленный след взлома на входной двери",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Обнаруженная на месте происшествия пуговица относится к группе \"следы - предметы\".",
						"ans": "Пуговица от куртки одного из преступников",
						"score": 0
					},
					{
						"comm": "Обнаруженные на месте происшествия частицы какого-либо вещества (в данном случае это мел) относятся к группе \"следы - вещества\".",
						"ans": "Частицы мела на полу у стеллажей с толом",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_10 = {
	"name": "krtex_4_10",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "Какие из перечисленных задач трасологического исследования относятся к диагностическим?",
				"correct_ans": [
					{
						"ans": "Определение пригодности следов для идентификации",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Установление групповой принадлежности",
						"score": 0
					},
					{
						"ans": "Установление тождества",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Установление групповой принадлежности или установление тождества относится к идентификационным задачам, а определение пригодности следов для идентификации - к диагностическим"
}

export let krtex_4_11 = {
	"name": "krtex_4_11",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "В каком из перечисленных типов папиллярных узоров пальцев рук имеется не менее двух дельт?",
				"correct_ans": [
					{
						"ans": "Завитковом",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "В дуговом узоре нет дельт.",
						"ans": "Дуговом",
						"score": 0
					},
					{
						"comm": "В петлевом узоре только одна дельта.",
						"ans": "Петлевом",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_12 = {
	"name": "krtex_4_12",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "На столе в складе взрывчатых материалов обнаружено три следа пальцев рук, относящихся к разным типам узоров: дуговой, петлевой и завитковый. В каком из перечисленных типов папиллярных узоров пальцев рук имеется одна дельта?",
				"correct_ans": [
					{
						"ans": "Петлевом",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "В дуговом узоре нет дельт.",
						"ans": "Дуговом",
						"score": 0
					},
					{
						"comm": "В завитковом узоре дельт не менее двух.",
						"ans": "Завитковом",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_13 = {
	"name": "krtex_4_13",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "Назовите основные свойства папиллярных узоров:",
				"correct_ans": [
					{
						"ans": "Индивидуальность",
						"score": 15
					},
					{
						"ans": "Относительная устойчивость",
						"score": 15
					},
					{
						"ans": "Отображаемость",
						"score": 15
					},
					{
						"ans": "Восстанавливаемость",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"ans": "Изменяемость под действием силы, эластичность",
						"score": 0
					},
					{
						"ans": "Отождествляемость",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_4_14 = {
	"name": "krtex_4_14",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "На земле обнаружена дорожка следов ног. Один из них наиболее хорошо отобразился. Укажите частный признак этого следа",
				"correct_ans": [
					{
						"ans": "Форма и размер набойки",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Указанный признак относится к общим признакам следа.",
						"ans": "Длина каблука",
						"score": 0
					},
					{
						"comm": "Указанный признак относится к общим признакам следа.",
						"ans": "Ширина промежуточной части",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_15 = {
	"name": "krtex_4_15",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "В какую сторону обращены сужения пятен от падающих при движении транспортного средства масла?",
				"correct_ans": [
					{
						"ans": "В сторону движения",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "В сторону противоположную движению",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_16 = {
	"name": "krtex_4_16",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "В какую сторону увеличивается глубина следа на грунте при пробуксовке?",
				"correct_ans": [
					{
						"ans": "В сторону противоположную движению",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "В сторону движения",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_17 = {
	"name": "krtex_4_17",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "В какую сторону обращены пологие стороны уступов на дне объемных следов?",
				"correct_ans": [
					{
						"ans": "В сторону противоположную движению",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "В сторону движения",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_4_18 = {
	"name": "krtex_4_18",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "На месте обнаружения трупа обнаружен объемный след обуви, на дне которого имеются частицы белого вещества, похожего на мел, отслоившиеся от подошвы в момент следообразования. Как наиболее целесообразно зафиксировать след?",
				"correct_ans": [
					{
						"ans": "Закрепить и изъять с почвой",
						"score": 30
					},
					{
						"ans": "Сфотографировать",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"comm": "Изготовление слепка нецелесообразно, т. к. в этом случае след-вещество будет утрачено.",
						"ans": "Изготовить слепок",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_4_19 = {
	"name": "krtex_4_19",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "На входной двери магазина взломан замок - перепилена дужка. Где вероятнее всего будут находиться металлические опилки?",
				"correct_ans": [
					{
						"ans": "На месте взлома у двери",
						"score": 30
					},
					{
						"ans": "На одежде и обуви подозреваемого",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"ans": "На полу в торговом зале",
						"score": 0
					},
					{
						"ans": "На прилавке в магазине",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_4_20 = {
	"name": "krtex_4_20",
	"descriprion": "type2",
	"theme": "Трассология",
	"title": "Трассология",
	"data": {
		"questions": [
			{
				"qst": "Укажите элементы дорожки следов",
				"correct_ans": [
					{
						"ans": "Угол разворота стопы",
						"score": 12
					},
					{
						"ans": "Ширина постановки ног",
						"score": 12
					},
					{
						"ans": "Линия ходьбы",
						"score": 12
					},
					{
						"ans": "Угол шага",
						"score": 12
					},
					{
						"ans": "Длина шага",
						"score": 12
					}
				],
				"wrong_ans": [
					{
						"ans": "Длина стопы Длина стопы - это элемент характеристики следа",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_5_1 = {
	"name": "krtex_5_1",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Как определить величину такого анатомического признака как рост человека?",
				"correct_ans": [
					{
						"ans": "Непосредственным измерением",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Сопоставлением с ростом других людей",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Сопоставлением роста человека 170 см.(средний рост) с ростом человека 125 см.(очень маленький) мы на этом основании и при таком методе придем к выводу, что первый человек высокого роста. Это не будет соответствовать общепринятой криминалистической классификации этого признака, так как по ней высокий рост - 175 см. и выше"
}

export let krtex_5_2 = {
	"name": "krtex_5_2",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Как определить величину такого анатомического признака как нос?",
				"correct_ans": [
					{
						"ans": "Сопоставлением с другими частями лица",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Непосредственным измерением",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "У одного человека с крупным лицом нос, скажем длиной 8 см., будет выглядеть средним по размеру, такой же длины нос у человека с малой головой будет выглядеть, конечно, большим"
}

export let krtex_5_3 = {
	"name": "krtex_5_3",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "При описании внешности преступника были отражены некоторые признаки. Какие из них функциональные?",
				"correct_ans": [
					{
						"ans": "Заикание",
						"score": 30
					},
					{
						"ans": "Хромота",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"comm": "Этот признак относится к анатомическим признакам тела человека.",
						"ans": "Высокий рост",
						"score": 0
					},
					{
						"comm": "Этот признак относится к анатомическим признакам тела человека.",
						"ans": "Горб",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_5_4 = {
	"name": "krtex_5_4",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "К теоретическим основам криминалистического изучения внешности человека относится...",
				"correct_ans": [
					{
						"ans": "индивидуальность",
						"score": 30
					},
					{
						"ans": "относительная устойчивость",
						"score": 30
					}
				],
				"wrong_ans": [
					{
						"ans": "полнота описания признаков",
						"score": 0
					},
					{
						"ans": "систематичность",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "К теоретическим основам криминалистического изучения внешности человека, относятся индивидуальность и относительная устойчивость признаков",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_5_5 = {
	"name": "krtex_5_5",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "При описании внешности преступника были отражены некоторые признаки. Какой из них анатомический?",
				"correct_ans": [
					{
						"ans": "Приподнятое основание носа",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Жестикуляция - это функциональный признак внешности человека.",
						"ans": "Жестикуляция",
						"score": 0
					},
					{
						"comm": "Прихрамывание - это функциональный признак внешности человека.",
						"ans": "Прихрамывание",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_5_6 = {
	"name": "krtex_5_6",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Назовите \"особые приметы\" анатомического происхождения",
				"correct_ans": [
					{
						"ans": "Следы оспы на лице",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Низкий рост",
						"score": 0
					},
					{
						"ans": "Большой нос",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Особые приметы - это выдающиеся, легко запоминающиеся признаки внешности, которые резко выделяют данного человека от других. Низкий рост и большой нос не обладают в достаточной степени такой характеристикой"
}

export let krtex_5_7 = {
	"name": "krtex_5_7",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Что понимается под термином \"Словесный портрет\"?",
				"correct_ans": [
					{
						"ans": "система описания внешности человека",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Кроме анатомических признаков есть и функциональные (походка, мимика, жестикуляция, голос и др. ), а также общефизические (пол, возраст, тип и др. ).",
						"ans": "система описания анатомических признаков человека",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_5_8 = {
	"name": "krtex_5_8",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Что из перечисленного может быть источниками информации о внешнем облике человека?",
				"correct_ans": [
					{
						"ans": "Показания свидетелей и потерпевших",
						"score": 15
					},
					{
						"ans": "Документы",
						"score": 15
					},
					{
						"ans": "Труп и костные останки",
						"score": 15
					},
					{
						"ans": "Фотоснимки и видеозаписи",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Протоколы следственных действий не всегда содержат информацию о внешнем облике человека.",
						"ans": "Протоколы следственных действий",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_5_9 = {
	"name": "krtex_5_9",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "К каким из перечисленных признаков относятся анатомические и функциональные аномалии?",
				"correct_ans": [
					{
						"ans": "К особым приметам",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "К общим признакам внешности",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Аномалии - это врожденные или приобретенные дефекты, уродства человека (например, отсутствие глаза, уха, конечности, заикание, тик и т.п.). Эти признаки безусловно редко встречающиеся, броские и легко запоминающиеся, а потому называются особыми приметами"
}

export let krtex_5_10 = {
	"name": "krtex_5_10",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Кем была впервые создана специальная методика описания внешнего облика человека, названная \"словесный портрет\"?",
				"correct_ans": [
					{
						"ans": "А. Бертильоном",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Г. Гроссом",
						"score": 0
					},
					{
						"ans": "Р. Белкиным",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_5_11 = {
	"name": "krtex_5_11",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "В приведенном перечне выделите группы признаков внешности человека",
				"correct_ans": [
					{
						"comm": "Особые приметы - это редко встречающиеся, легко запоминающиеся признаки внешности человека. Естественно, что они лишь часть в классификации признаков внешности.",
						"ans": "Особые приметы",
						"score": 15
					},
					{
						"ans": "Анатомические признаки",
						"score": 15
					},
					{
						"ans": "Функциональные признаки",
						"score": 15
					},
					{
						"ans": "Сопутствующие",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Скрытых признаков нет.",
						"ans": "Скрытые признаки",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_5_12 = {
	"name": "krtex_5_12",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Голос как функциональный признак человека различается по...",
				"correct_ans": [
					{
						"ans": "силе",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "темпу",
						"score": 0
					},
					{
						"ans": "интонации",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Темп и интонация относятся к признакам речи, а не голоса"
}

export let krtex_5_13 = {
	"name": "krtex_5_13",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Речь как функциональный признак человека различается по...",
				"correct_ans": [
					{
						"ans": "внятности",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "высоте",
						"score": 0
					},
					{
						"ans": "тембру",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Высота и тембр относятся к признакам голоса, а не речи"
}

export let krtex_5_14 = {
	"name": "krtex_5_14",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Какие из перечисленных параметров обязательны при описании анатомических признаков внешности?",
				"correct_ans": [
					{
						"ans": "Величина",
						"score": 20
					},
					{
						"ans": "Форма (контур)",
						"score": 20
					},
					{
						"ans": "Положение, цвет",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Индивидуальность и степень устойчивости являются общими свойствами внешности.",
						"ans": "Индивидуальность и степень устойчивости",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_5_15 = {
	"name": "krtex_5_15",
	"descriprion": "type2",
	"theme": "Габитология",
	"title": "Габитология",
	"data": {
		"questions": [
			{
				"qst": "Могут ли быть объектами экспертного отождествления человека по признакам внешности портреты, выполненные художником?",
				"correct_ans": [
					{
						"ans": "Нет",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Да",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Портрет художника может быть использован для отождествления человека по признакам внешности, например при проведении такого следственного действия как предъявление для опознания личности. Для экспертного же отождествления требуются объекты только в натуре (живой человек, труп человека, костные останки) или их копии, но выполненные с помощью технических средств (фото-видеосъемки) и другими способами, объективно отражающими признаки внешности"
}

export let krtex_6_1 = {
	"name": "krtex_6_1",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Письменные документы как доказательства делятся на 2 группы: документы - вещественные доказательства и документы - письменные доказательства. Какой из указанных документов является письменным доказательством?",
				"correct_ans": [
					{
						"ans": "Официальная характеристика с места работы подозреваемого",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Подложное авизо",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Если на письменных документах есть признаки подделки, то они могут быть признаны вещественными доказательствами и приобщены к уголовному делу, как, например, подложное авизо. Все остальные документы, имеющие отношение к данному делу, но не содержащие какие-либо следы преступления, относятся к письменным документам. Вот в чем разница между теми и другими видами документов"
}

export let krtex_6_2 = {
	"name": "krtex_6_2",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Определите способ частичной подделки документа по перечисленным признакам: нарушение структуры поверхностного слоя бумаги; утоньшение бумаги в месте подделки; повреждение линий защитной сетки; расплывы и более глубокое проникновение в толщу бумаги чернил в штрихах",
				"correct_ans": [
					{
						"ans": "Подчистка",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Некоторые признаки травления могут иметь место и при подчистке: нарушение структуры поверхностного слоя бумаги; повреждение линий защитной сетки; расплывы чернил. Однако для травления обязательны и некоторые другие признаки, которых здесь нет.",
						"ans": "Травление",
						"score": 0
					},
					{
						"comm": "Некоторые признаки смыва могут иметь место и при подчистке, например, расплывы чернил. Однако для смыва обязательны и некоторые другие признаки, которых здесь нет.",
						"ans": "Смыв",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_3 = {
	"name": "krtex_6_3",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Определите способ частичной подделки документа по перечисленным признакам: появление матовой поверхности; изменение цвета бумаги; образование микротрещин на бумаге; обесцвечивание или изменение цвета защитной сетки; расплывы чернил",
				"correct_ans": [
					{
						"ans": "Травление",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Некоторые признаки подчистки могут иметь место и при травлении, например, расплывы чернил. Однако для подчистки обязательны и некоторые другие признаки, которых здесь нет.",
						"ans": "Подчистка",
						"score": 0
					},
					{
						"comm": "Некоторые признаки смыва могут иметь место и при травлении, например, расплывы чернил. Однако для смыва обязательны и некоторые другие признаки, которых здесь нет.",
						"ans": "Смыв",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_4 = {
	"name": "krtex_6_4",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Определите способ частичной подделки документа по перечисленным признакам: нарушение проклейки бумаги; изменение цвета бумаги; обесцвечивание или изменение цвета защитной сетки, линий графления штрихов соседних записей; расплывы чернил",
				"correct_ans": [
					{
						"ans": "Смыв",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Некоторые признаки подчистки могут иметь место и при смыве, например, расплывы чернил. Однако для подчистки обязательны и некоторые другие признаки, которых здесь нет.",
						"ans": "Подчистка",
						"score": 0
					},
					{
						"comm": "Некоторые признаки травления могут иметь место и при смыве, например, расплывы чернил. Однако для травления обязательны и некоторые другие признаки, которых здесь нет.",
						"ans": "Травление",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_5 = {
	"name": "krtex_6_5",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Чья личность может быть установлена по письменной речи?",
				"correct_ans": [
					{
						"ans": "Автор документа",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Исполнитель документа",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Исполнитель - тот, кто написал документ. Признаки же речи характеризуют автора, то есть сочинителя текста. Если автор сам выполнил текст, то в этом случае он будет и исполнителем"
}

export let krtex_6_6 = {
	"name": "krtex_6_6",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Чья личность может быть установлена по почерку?",
				"correct_ans": [
					{
						"ans": "Исполнитель документа",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Автор документа",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Признаки почерка отображают индивидуальные навыки написания письменных знаков того, кто его написал, то есть исполнителя. Автором текста может быть и другой человек"
}

export let krtex_6_7 = {
	"name": "krtex_6_7",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "В чем проявляется индивидуальность письма?",
				"correct_ans": [
					{
						"ans": "письменной речи и особенностях написания письменных знаков",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "только в особенностях написания письменных знаков",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В криминалистическое понятие \"письмо\" включается как индивидуальность письменной речи, так и особенности написания письменных знаков"
}

export let krtex_6_8 = {
	"name": "krtex_6_8",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "В процессе исследования письма изучается письменная речь, топография письма и почерк. Что является признаками письменной речи?",
				"correct_ans": [
					{
						"ans": "Грамматические особенности",
						"score": 20
					},
					{
						"ans": "Лексические особенности письма",
						"score": 20
					},
					{
						"ans": "Стилистические особенности письма",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"ans": "Особенности выделения абзацев; перенос слов; способы вставок",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Особенности выделения абзацев, перенос слов, способы вставок и другие - это топографические признаки, а не признаки письменной речи",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_6_9 = {
	"name": "krtex_6_9",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Что относится к топографическим признакам письма?",
				"correct_ans": [
					{
						"ans": "Расположение строк",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Выработанность почерка",
						"score": 0
					},
					{
						"ans": "Размер почерка",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Выработанность и размер почерка (а также некоторые другие признаки) относятся к признакам почерка (в данном случае это частные признаки почерка)"
}

export let krtex_6_10 = {
	"name": "krtex_6_10",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Классификация почерка на простой, упрощенный, усложненный относится ...",
				"correct_ans": [
					{
						"ans": "к общему типу почерка",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "к выработанности почерка",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Выработанность почерка подразделяется на выработанный (высокая степень), средней выработанности и малой выработанности"
}

export let krtex_6_11 = {
	"name": "krtex_6_11",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Признаки почерка делятся на общие и частные. В приведенном перечне укажите частный признак почерка",
				"correct_ans": [
					{
						"ans": "Особенности направления движения при выполнении письменных знаков и их элементов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Выработанность почерка",
						"score": 0
					},
					{
						"ans": "Размер знаков",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Выработанность и размер почерка относятся к общим признакам почерка, а не к частным"
}

export let krtex_6_12 = {
	"name": "krtex_6_12",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Для какого способа технической подделки подписи характерны следующие признаки: извилистость штрихов; изломы овалов; тупые начала и окончания штрихов; остатки красителя?",
				"correct_ans": [
					{
						"ans": "Копирование через копировальную бумагу",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Для таких способов технической подделки подписи как копирование с помощью копирующих материалов и использование клише характерны совершенно другие признаки.",
						"ans": "Копирование с помощью копирующих материалов",
						"score": 0
					},
					{
						"comm": "Для таких способов технической подделки подписи как копирование с помощью копирующих материалов и использование клише характерны совершенно другие признаки.",
						"ans": "Использование клише",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_13 = {
	"name": "krtex_6_13",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Для какого способа подделки подписи характерны следующие признаки: нечеткость изображения; расплывы красителя; люминесценция поверхности бумаги в районе подписи при освещении УФЛ?",
				"correct_ans": [
					{
						"ans": "Копирование с помощью копирующих материалов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Для таких способов технической подделки подписи как копирование подписи через копирующую бумагу и использование клише характерны совершенно другие признаки.",
						"ans": "Копирование подписи через копировальную бумагу",
						"score": 0
					},
					{
						"comm": "Для таких способов технической подделки подписи как копирование подписи через копирующую бумагу и использование клише характерны совершенно другие признаки.",
						"ans": "Использование клише",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_14 = {
	"name": "krtex_6_14",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Для какого способа подделки подписи характерны следующие признаки: извилистость штрихов; изломы овалов; тупые начала и окончания штрихов; подрисовки штрихов?",
				"correct_ans": [
					{
						"ans": "Срисовывания с последующей обводкой",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Для копирования через копировальную бумагу также возможны некоторые из указанных признаков (извилистость штрихов;изломы овалов; тупые начала и окончания штрихов), но характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Копирование через копировальную бумагу",
						"score": 0
					},
					{
						"comm": "Для такого способа как передавливание с последующей обводкой также возможны некоторые из указанных признаков (извилистость штрихов; изломы овалов; тупые начала и окончания штрихов), но характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Путем передавливания с последующей обводкой",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_15 = {
	"name": "krtex_6_15",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "Как правильно осуществить получение образцов почерка у подозреваемого?",
				"correct_ans": [
					{
						"ans": "Образцы выполняются им под диктовку",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Подозреваемый сам переписывает исследуемый текст",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Недопустимо предлагать подозреваемому сам текст для того, чтобы он его переписал, так как на суде он сможет заявить, что, обладая хорошими способностями, умело перекопировал данный текст, хотя фактически писал его не он, а кто-то другой. Тем самым будет поставлено под сомнение доказательственная сила, проведенной вслед за этим почерковедческой экспертизы"
}

export let krtex_6_16 = {
	"name": "krtex_6_16",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "На какой способ подделки оттисков печатей и штампов указывают следующие признаки: различный размер одноименных знаков; ломаные линии строк; неравномерность интервалов между буквами, словами; зеркальность, перевернутость отдельных букв?",
				"correct_ans": [
					{
						"ans": "Оттиск нанесен плоским рисованным клише",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ряд указанных здесь признаков относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на мягком материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на твердом материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск получен с помощью промежуточного клише путем откопирования на предмет,обладающий копировальной способностью",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск изготовлен путем его рисования",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_17 = {
	"name": "krtex_6_17",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "На какой способ подделки оттисков печатей и штампов указывают следующие признаки: слабая окрашенность штрихов; расплывы красящего вещества; отсутствие глянца бумаги; наличие штрихов, не относящихся к изображению печати?",
				"correct_ans": [
					{
						"ans": "Оттиск получен с помощью промежуточного клише путем откопирования на предмет,обладающий копировальной способностью",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ряд указанных здесь признаков действительно относятся и к данному способу подделки. Однако, скажем такой признак как наличие штрихов, не относящихся к изображению печати, явно не к месту. Кроме того, некоторые характерные признаки здесь вовсе отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на мягком материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся и к данному способу подделки. Однако, скажем такой признак как наличие штрихов, не относящихся к изображению печати, явно не к месту. Кроме того, некоторые характерные признаки здесь вовсе отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на твердом материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся и к данному способу подделки. Однако, скажем такой признак как наличие штрихов, не относящихся к изображению печати, явно не к месту. Кроме того, некоторые характерные признаки здесь вовсе отсутствуют.",
						"ans": "Оттиск нанесен плоским рисованным клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся и к данному способу подделки. Однако, скажем такой признак как наличие штрихов, не относящихся к изображению печати, явно не к месту. Кроме того, некоторые характерные признаки здесь вовсе отсутствуют.",
						"ans": "Оттиск изготовлен путем его рисования",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_18 = {
	"name": "krtex_6_18",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "На какой способ подделки оттисков печатей и штампов указывают следующие признаки: различный размер и конфигурация знаков; отклонение осей букв от радиусов окружности оттиска; ломаные линии строк; неравномерность интервалов между знаками; скосы углов в местах соединения штрихов знаков; заостренные окончания штрихов; зазубрины по краям штрихов?",
				"correct_ans": [
					{
						"ans": "Оттиск нанесен вырезанным на мягком материале клише",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на твердом материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен плоским рисованным клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск получен с помощью промежуточного клише путем откопирования на предмет,обладающий копировальной способностью",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск изготовлен путем его рисования",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_19 = {
	"name": "krtex_6_19",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "На какой способ подделки оттисков печатей и штампов укозывают следующие признаки: различный размер и конфигурация знаков; отклонение осей букв от радиусов окружности оттиска; ломаные линии строк; неравномерность интервалов между знаками; скосы углов в местах соединения штрихов знаков; заостренные окончания штрихов; зазубрины по краям штрихов; неравномерное, с множественными \"просветами\", распределение красящего вещества, выход его за границу штрихов?",
				"correct_ans": [
					{
						"ans": "Оттиск нанесен вырезанным на твердом материале клише",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на мягком материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен плоским рисованным клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск получен с помощью промежуточного клише путем откопирования на предмет,обладающий копировальной способностью",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск изготовлен путем его рисования",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_6_20 = {
	"name": "krtex_6_20",
	"descriprion": "type2",
	"theme": "Исследование документов",
	"title": "Исследование документов",
	"data": {
		"questions": [
			{
				"qst": "На какой способ подделки оттисков печатей и штампов указывают следующие признаки: различный размер и конфигурация знаков; сдвоенные штрихи, бороздки; прокол в центре оттиска; нарушение геометрической формы; ассиметричное расположение частей текста и изображений?",
				"correct_ans": [
					{
						"ans": "Оттиск изготовлен путем его рисования",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на мягком материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен вырезанным на твердом материале клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск нанесен плоским рисованным клише",
						"score": 0
					},
					{
						"comm": "Ряд указанных здесь признаков действительно относятся к выбранному Вами способу подделки. Однако, для данного способа характерны и иные признаки, которые здесь отсутствуют.",
						"ans": "Оттиск получен с помощью промежуточного клише путем откопирования на предмет,обладающий копировальной способностью",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_1 = {
	"name": "krtex_7_1",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "Криминалистические учеты делятся на три группы:",
				"correct_ans": [
					{
						"ans": "Оперативно-справочные, розыскные и криминалистические",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Оперативные, справочные и криминалистические",
						"score": 0
					},
					{
						"ans": "Оперативно-розыскные, справочные и экспертно-криминалистические коллекции",
						"score": 0
					},
					{
						"ans": "Розыскные, криминалистические и дактилоскопические",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_2 = {
	"name": "krtex_7_2",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "Проверка наличия установочных сведений об объекте, его местонахождении на момент запроса, сравнение как установочных данных, так и сходных внешних описаний - сущность функционирования...",
				"correct_ans": [
					{
						"ans": "розыскных учетов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "К оперативно-справочным учетам относится проверка наличия установочных сведений об объекте и его местонахождении на момент запроса.",
						"ans": "оперативно-справочных учетов",
						"score": 0
					},
					{
						"comm": "К криминалистическим учетам относится реализация диагностических и идентификационных целей по индивидуальным приметам и другим признакам объектов, когда установочные данные неизвестны или скрываются.",
						"ans": "криминалистических учетов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_3 = {
	"name": "krtex_7_3",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "Реализация диагностических и идентификационных целей по индивидуальным приметам и другим признакам объектов, когда установочные данные неизвестны или скрываются - сущность функционирования...",
				"correct_ans": [
					{
						"ans": "криминалистических учетов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "К оперативно-справочным учетам относится проверка наличия установочных сведений об объекте и его местонахождении на момент запроса.",
						"ans": "оперативно-справочных учетов",
						"score": 0
					},
					{
						"comm": "К розыскным учетам относится проверка наличия установочных сведений об объекте,его местонахождении на момент запроса, сравнение как установочных данных,так и сходных внешних описаний.",
						"ans": "розыскных учетов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_4 = {
	"name": "krtex_7_4",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "Проверка наличия установочных сведений об объекте и его местонахождении на момент запроса - сущность функционирования...",
				"correct_ans": [
					{
						"ans": "оперативно-справочных учетов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "К розыскным учетам относится проверка наличия установочных сведений об объекте,его местонахождении на момент запроса, сравнение как установочных данных,так и сходных внешних описаний.",
						"ans": "розыскных учетов",
						"score": 0
					},
					{
						"comm": "К криминалистическим учетам относится реализация диагностических и идентификационных целей по индивидуальным приметам и другим признакам объектов, когда установочные данные неизвестны или скрываются.",
						"ans": "криминалистических учетов",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_5 = {
	"name": "krtex_7_5",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "В розыскных централизованных учетах ведется:",
				"correct_ans": [
					{
						"ans": "учет лиц; учет похищенных и изъятых предметов",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Учеты лиц, учеты преступлений и правонарушений ведутся в оперативно-справочных учетах.",
						"ans": "учеты лиц; учеты преступлений и правонарушений",
						"score": 0
					},
					{
						"comm": "Учеты лиц, учеты преступлений (обстоятельства и способы совершения преступлений) ведутся в криминалистических учетах.",
						"ans": "учеты лиц; учеты преступлений (обстоятельства и способы совершения преступлений)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_6 = {
	"name": "krtex_7_6",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "В оперативно-справочных централизованных учетах ведется:",
				"correct_ans": [
					{
						"ans": "учеты лиц; учеты преступлений и правонарушений",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Учет лиц, учет похищенных и изъятых предметов ведется в розыскных учетах.",
						"ans": "учет лиц; учет похищенных и изъятых предметов",
						"score": 0
					},
					{
						"comm": "Учеты лиц, учеты преступлений (обстоятельства и способы совершения преступлений) ведутся в криминалистических учетах.",
						"ans": "учеты лиц; учеты преступлений (обстоятельства и способы совершения преступлений)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_7 = {
	"name": "krtex_7_7",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "В криминалистических централизованных учетах ведется:",
				"correct_ans": [
					{
						"ans": "учеты лиц; учеты преступлений (обстоятельства и способы совершения преступлений)",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": ". Учет лиц, учет похищенных и изъятых предметов ведется в розыскных учетах.",
						"ans": "учет лиц; учет похищенных и изъятых предметов",
						"score": 0
					},
					{
						"comm": "Учеты лиц, учеты преступлений и правонарушений ведутся в оперативно-справочных учетах.",
						"ans": "учеты лиц; учеты преступлений и правонарушений",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_8 = {
	"name": "krtex_7_8",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "Дактилоскопический учет осужденных осуществляется в рамках:",
				"correct_ans": [
					{
						"ans": "оперативно-справочного учета",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "розыскного учета",
						"score": 0
					},
					{
						"ans": "криминалистического учета",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В розыскном и криминалистическом учете не ведется учета осужденных"
}

export let krtex_7_9 = {
	"name": "krtex_7_9",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "Учет без вести пропавших, неизвестных больных и детей осуществляется в рамках:",
				"correct_ans": [
					{
						"ans": "криминалистического учета",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "оперативно-справочного",
						"score": 0
					},
					{
						"ans": "розыскного",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В оперативно-справочном и розыскном учетах не ведется учета неизвестных больных и детей"
}

export let krtex_7_10 = {
	"name": "krtex_7_10",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "К криминалистическому учету относится:",
				"correct_ans": [
					{
						"ans": "учет неопознанных трупов граждан",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Пофамильный учет осужденных относится к оперативно-справочному учету.",
						"ans": "пофамильный учет осужденных",
						"score": 0
					},
					{
						"comm": "Дактилоскопический учет осужденных относится к оперативно-справочному учету.",
						"ans": "дактилоскопический учет осужденных",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_7_11 = {
	"name": "krtex_7_11",
	"descriprion": "type2",
	"theme": "Криминалистические учеты",
	"title": "Криминалистические учеты",
	"data": {
		"questions": [
			{
				"qst": "Исключите из предлагаемого перечня ту категорию лиц, которая не ставится на федеральный учет",
				"correct_ans": [
					{
						"ans": "Совершившие общественно-опасные деяния, помещенные по решению суда в психиатрические больницы для принудительного лечения",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Осужденные на территории России к исключительной мере наказания - смертной казни и лишению свободы",
						"score": 0
					},
					{
						"ans": "Осужденные в иностранном государстве и переданные России для отбывания наказания",
						"score": 0
					},
					{
						"ans": "Осужденные к лишению свободы условно, а также с отсрочкой исполнения приговора, в отношении которых судом вынесено определение о направлении в места лишения свободы",
						"score": 0
					},
					{
						"ans": "Лица, объявленные в розыск органами безопасности, внутренних дел и прокуратуры",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_1 = {
	"name": "krtex_8_1",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Промежутки между винтообразными углублениями на внутренней стенке канала ствола называются ...",
				"correct_ans": [
					{
						"ans": "полями",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "нарезами",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Нарезы - винтообразные углубления на внутренней стенке канала ствола"
}

export let krtex_8_2 = {
	"name": "krtex_8_2",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Углубления на внутренней стенке канала ствола называются...",
				"correct_ans": [
					{
						"ans": "нарезами",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "полями",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Поля - это промежутки между винтообразными углублениями на внутренней стенке канала ствола"
}

export let krtex_8_3 = {
	"name": "krtex_8_3",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Калибр в нарезном оружии - это расстояние между противоположно расположенными...",
				"correct_ans": [
					{
						"ans": "Полями",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Нарезами",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_4 = {
	"name": "krtex_8_4",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Калибр охотничьего ружья - это...",
				"correct_ans": [
					{
						"ans": "условное обозначение,соответствующее количеству шариковых пуль,диаметром равных диаметру канала ствола,которые можно отлить из фунта (485,5 г.) свинца",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "внутренний диаметр канала ствола",
						"score": 0
					},
					{
						"ans": "условное обозначение,соответствующее количеству дробин (с номером \"0\"),умещающихся в преграде диаметром 5 дюймов (12,5 см.) при выстреле с расстояния 10 м",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_5 = {
	"name": "krtex_8_5",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Унитарный патрон - это...",
				"correct_ans": [
					{
						"ans": "патрон, состоящий из гильзы, капсюля, снаряда и заряда пороха",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "патрон особой конструкции (бронебойный, зажигательный, трассирующий и т.п.)",
						"score": 0
					},
					{
						"ans": "патрон, который может использоваться в различных системах огнестрельного оружия одного с ним калибра",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_6 = {
	"name": "krtex_8_6",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Что соответствует диаметру гильзы?",
				"correct_ans": [
					{
						"ans": "Внутренний диаметр дульца",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Внешний диаметр дульца",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_7 = {
	"name": "krtex_8_7",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Диаметр ведущей части пули...",
				"correct_ans": [
					{
						"ans": "превышает диаметр канала ствола",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "соответствует диаметру канала ствола",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Диаметр ведущей части пули должен быть несколько больше диаметра канала ствола для того, чтобы пуля врезалась в нарезы и таким образом могла получить вращательное движение. Если диаметр ведущей части пули и диаметр канала ствола будет одинаков, то пуля не получит вращательного движения"
}

export let krtex_8_8 = {
	"name": "krtex_8_8",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Картечь - это дробь...",
				"correct_ans": [
					{
						"ans": "диаметр которой превышает 5 мм",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "номер которой 9 и более",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_9 = {
	"name": "krtex_8_9",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Назовите обстоятельства, которые можно установить путем исследования стреляных пуль и гильз",
				"correct_ans": [
					{
						"ans": "Вид и система оружия",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"comm": "Для установления конкретного экземпляра оружия по стреляным пулям и гильзам необходимо представить эксперту и само огнестрельное оружие.",
						"ans": "Конкретный экземпляр оружия",
						"score": 0
					},
					{
						"comm": "Для установления направления выстрела мало исследования стреляных пуль и гильз, необходимо еще исследование места происшествия, где произведены выстрелы, объекты со следами выстрела.",
						"ans": "Направление выстрела",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_10 = {
	"name": "krtex_8_10",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "У задержанного хулигана изъяли предмет, похожий на детский пугач. Какой вопрос необходимо поставить эксперту в первую очередь?",
				"correct_ans": [
					{
						"ans": "Является ли данный предмет огнестрельным оружием?",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Изготовлено ли оружие самим преступником?",
						"score": 0
					},
					{
						"ans": "Можно ли произвести из данного оружия выстрел?",
						"score": 0
					},
					{
						"ans": "Возможен ли выстрел без нажатия на спусковой крючок?",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Все вопросы могут задаваться эксперту только после ответа на вопрос \"Является ли данный предмет огнестрельным оружием?"
}

export let krtex_8_11 = {
	"name": "krtex_8_11",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Осматривая обнаруженный на месте происшествия пистолет, следователь в протоколе осмотра записал: \"В канале ствола ощущается запах пороховых газов\". Правильно ли поступил следователь?",
				"correct_ans": [
					{
						"ans": "Да",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Следователь фиксирует в протоколе осмотра признаки осматриваемых объектов, используя необходимые органы чувств, в том числе и обоняние"
}

export let krtex_8_12 = {
	"name": "krtex_8_12",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Какой вопрос необходимо поставить эксперту в первую очередь о предмете, похожем на нож?",
				"correct_ans": [
					{
						"ans": "Является ли данный предмет холодным оружием?",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Каким способом изготовлен предмет?",
						"score": 0
					},
					{
						"ans": "Как давно изготовлено это оружие?",
						"score": 0
					},
					{
						"ans": "К какому виду холодного оружия относится данный предмет?",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Все вопросы могут задаваться эксперту только после ответа на вопрос \"Является ли данный предмет холодным оружием?\""
}

export let krtex_8_13 = {
	"name": "krtex_8_13",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "При личном обыске у задержанного был изъят охотничий нож заводского изготовления. Следует ли назначать экспертизу для установления принадлежности его к холодному оружию?",
				"correct_ans": [
					{
						"ans": "Да",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Только специалист может определить, к какому типу ножей относится представленный нож и каким способом он изготовлен"
}

export let krtex_8_14 = {
	"name": "krtex_8_14",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Каков размер пулевых пробоин в пластичных материалах?",
				"correct_ans": [
					{
						"ans": "меньше диаметра пули",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "больше диаметра пули",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_15 = {
	"name": "krtex_8_15",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Каков размер пробоин в хрупких материалах?",
				"correct_ans": [
					{
						"ans": "Больше диаметра пули",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Меньше диаметра пули",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_16 = {
	"name": "krtex_8_16",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Какие следы можно обнаружить при осмотре предмета с огнестрельным повреждением?",
				"correct_ans": [
					{
						"ans": "Копоть и ожоги",
						"score": 15
					},
					{
						"ans": "Дробь, пулю",
						"score": 15
					},
					{
						"ans": "Порошины",
						"score": 15
					},
					{
						"ans": "Пробоины",
						"score": 15
					}
				],
				"wrong_ans": [
					{
						"comm": "Гильзу обнаружить невозможно, т. к. гильза не может внедриться в поврежденный объект.",
						"ans": "Гильзу",
						"score": 0
					},
					{
						"comm": "След бойка обнаружить невозможно, т. к. этот след остается на гильзе.",
						"ans": "След бойка",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let krtex_8_17 = {
	"name": "krtex_8_17",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "Какое огнестрельное отверстие больше?",
				"correct_ans": [
					{
						"comm": "При соприкосновении с преградой происходит резкое падение кинетической энергии вращения снаряда и его головная часть начинает описывать круги все большего диаметра.",
						"ans": "Выходное",
						"score": 60
					}
				],
				"wrong_ans": [
					{
						"ans": "Входное",
						"score": 0
					},
					{
						"ans": "Глухое",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question"
}

export let krtex_8_18 = {
	"name": "krtex_8_18",
	"descriprion": "type2",
	"theme": "Криминалистическое исследование оружия и следов его применения",
	"title": "Криминалистическое исследование оружия и следов его применения",
	"data": {
		"questions": [
			{
				"qst": "На краях входного пулевого отверстия образуется поясок обтирания. При выстреле с близкого расстояния дополнительно возникают следы близкого выстрела. Укажите их",
				"correct_ans": [
					{
						"ans": "Внедрившиеся частицы пороха",
						"score": 20
					},
					{
						"ans": "Опаление (ожог)",
						"score": 20
					},
					{
						"ans": "Запекшаяся кровь",
						"score": 20
					}
				],
				"wrong_ans": [
					{
						"comm": "Частиц грязи не может быть.",
						"ans": "Частицы грязи",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

